import axios from 'axios';

import constants from '../../../constants';
import { ChecklistCertification, CustomerTraining, Training, UpcomingAppointment, UserTraining } from './types';
import { SimpleFile } from '../../../helpers/downloadFile'

const ontraqBaseAPIURL2 = `${constants.ONTRAQ_API_URL}/api2`

export const getVendorToken = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/de/vendor-token`)
  const token: string = response.data.token

  return token
}

export const getUpcomingAppointments = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/de/next-appointment`)
  const upcoming: UpcomingAppointment | null = response.data

  return upcoming
}

export const certifyChecklistComplete = (customerNumber: string, checklistId: number) =>
  axios
    .post<ChecklistCertification>(`${ontraqBaseAPIURL2}/${customerNumber}/training-checklist-certifications/${checklistId}`)
    .then((res) => res.data)
    .catch((error) => {
      throw new Error(error.response.data.message ?? 'Failed to certify checklist');
    });

export const decertifyChecklist = (customerNumber: string, checklistId: number) =>
  axios.delete(`${ontraqBaseAPIURL2}/${customerNumber}/training-checklist-certifications/${checklistId}`);

export const getCompletedChecklists = (customerNumber: string) =>
  axios
    .get<ChecklistCertification[]>(`${ontraqBaseAPIURL2}/${customerNumber}/training-checklist-certifications`)
    .then((res) => res.data);

// TODO: it might be possible to filter by type as part of the request query, but I couldn't get it working.
// Regex was used here because currently "OSHA-HIPAA " is the type :weary:
const filterByOshaHippaType = <T extends { training: Training }>(data: T[]): T[] => {
  const oshaHipaaTrainings = data.filter((d) => {
    const type = d.training.category
    return /OSHA-HIPAA/i.test(type)
  })
  return oshaHipaaTrainings
}

export const getUserTraining = (customerNumber: string) =>
  axios
    .get<UserTraining[]>(
      `${ontraqBaseAPIURL2}/${customerNumber}/users-training/active`
    )
    .then((res) => res.data)
    .then(filterByOshaHippaType);

export const getCustomerTraining = (customerNumber: string) =>
  axios
    .get<CustomerTraining[]>(
      `${ontraqBaseAPIURL2}/${customerNumber}/customer-trainings`
    )
    .then((res) => res.data)
    .then(filterByOshaHippaType);

export const getTrainingForms = async (customerNumber: string, fileIds: number[], fileName: string): Promise<SimpleFile> => {
  const fileIdsToString = fileIds.join(',')
  const encodedFileIds = encodeURIComponent(fileIdsToString)
  const downloadUrl = `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/training-program-forms/training-forms/${encodedFileIds}`
  const response = await axios.get(downloadUrl, { responseType: 'blob' })
  const url = URL.createObjectURL(response.data)
  const isBlobURL = true
  return { url, fileName, isBlobURL }
}

export const getTrainingForm = async (customerNumber: string, fileId: number | null, fileName: string): Promise<SimpleFile> => {
  const downloadUrl = `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/training-program-forms/training-form/${fileId}`
  const response = await axios.get(downloadUrl, { responseType: 'blob' })
  const url = URL.createObjectURL(response.data)
  const isBlobURL = true
  return { url, fileName, isBlobURL }
}
